import { Frequency } from "../../../Wrap/Constants/Enums/Domain/Frequency";
import { SideMenu } from "../../../Wrap/Constants/Enums/Menu/SideMenu";

export class Contents {
    public static URLS = ["business-insight", "notification-centre", "clients", "tools-and-literature", "dashboard"];

    public static URLMap = {
        dashboard: "dashboard",
        account: "account",
        BusinessManagement: "business-management",
        toolsAndLiterature: "tools-and-literature",
        reports: "reports",
        remunerationstatement: "remuneration-statement",
        admin: "admin",
        settings: "settings",
        spt: "single-payment-transfer",
        buy: "buy",
        cancelOrder: "cancel-order",
        cancel: "cancel",
        regularPayment: "regular-payment",
        researchIst: "research-ist",
        sell: "sell",
        switch: "switch",
        switchTo: "switch-to",
        switchFrom: "switch-from",
        topUpWithITFLS: "top-up-with-itfls",
        orderSetup: "order-setup",
        accountClosureList: "account-closure-list",
        companyWizardHistory: "company-wizard-history",
        companyWizardInProgress: "company-wizard-inprogress",
        companySetup: "company-setup",
        companySetupWizard: "company-setup-wizard",
        companyView: "view-company",
        firmdetail: "firm-detail",
        remunerationAndValuation: "remuneration-valuation",
        alert: "alert",
        validationAndExcute: "validate-excute",
        networkSetupWizard: "network-setup-wizard",
        networkSetup: "network-setup",
        networkDetail: "network",
        networkServiceProvider: "network-detail",
        insuredFund: "insured-fund",
        client: "client",
        transferWizard: "transferWizard",
        transferWizardStepOne: "move-investement",
        transferWizardStepTwo: "preview-submit",
        networkSubmitted: "network-submitted",
        networkInProgress: "network-inprogress",
        newQuoteWizard: "new-quote",
        quoteReady: "quote-ready",
        drawdownDetail: "drawdown-detail",
        drawdownDetailSipp: "sipp-drawdown-detail",
        incomePayment: "income-payment",
        newBusinessWizard: "new-business",
        interestedPartiesWizard: "interested-parties",
        fullClientDetail: "full-client-detail",
        wrapperSelection: "wrapper-selection",
        paymentInISA: "isa-payments-in",
        adviserChargesISA: "isa-adviser-charges",
        withdrawalsISA: "isa-withdrawals",
        investmentSelectionISA: "isa-investment-selection",
        paymentInPP: "pp-payments-in",
        adviserChargesPP: "pp-adviser-charges",
        investmentSelectionPP: "pp-investment-selection",
        withdrawalsPP: "pp-withdrawals",
        paymentInSIPP: "sipp-payments-in",
        adviserChargesSIPP: "sipp-adviser-charges",
        investmentSelectionSIPP: "sipp-investment-selection",
        incomePaymentsSIPP: "sipp-income-payments",
        completeSIPP: "sipp-complete",
        paymentInJSIPP: "jsipp-payments-in",
        adviserChargesJSIPP: "jsipp-adviser-charges",
        investmentSelectionJSIPP: "jsipp-investment-selection",
        drawdownDetailJSIPP: "jsipp-drawdown-detail",
        incomePaymentsJSIPP: "jsipp-income-payments",
        completeJSIPP: "jsipp-complete",
        completeISA: "isa-complete",
        completePP: "pp-complete",
        paymentsInWrapCash: "wrap-cash-payments-in",
        paymentsInLegacyProduct: "legacy-product-payments-in",
        disinvestmentStrategy: "disinvestment-strategy",
        review: "review",
        documentAndDeclarations: "doc-and-declara",
        regularWithdrawals: "regular-withdrawals",
        confirmation: "confirmation",
        addClientWizard: "addClient",
        clientType: "client-type",
        clientDetails: "client-details",
        childDetails: "child-details",
        trustMember: "trust-member",
        trustDetail: "trust-detail",
        corporateMember: "corporate-member",
        corporateDetail: "corporate-detail",
        paymentIn: "payments-in",
        adviserCharges: "adivser-charges",
        ist: "ist",
        productOveriew: "productOveriew",
        newIncomePaymentOneOffWizard: "new-incomepayment-oneoffwizard",
        incomePaymentOneOff: "incomepayment-oneoff",
        incomePaymentOneOffDetail: "incomepayment-detail",
        incomePaymentOneOffReview: "review",
        incomePaymentOneOffDocumentsAndDeclations: "documents-and-declarations",
        incomePaymentOneOffConfirmation: "confirmation",
        updateLifetimeAllowance: "update-lifetime-allowance",
        updateLifetimeAllowanceDetail: "update-lifetime-allowance-detail",
        updateLifetimeAllowanceConfirmation: "update-lifetime-allowance-confirmation",
        pensionBenefits: "pension-benefits",
        pensionBenefitsDetails: "pension-benefits-details",
        pensionBenefitsIncomePayment: "tpb-income-payment",
        convertCappedToFlexiWizard: "convert-capped-to-flexi",
        convertCappedToFlexi: "convert-capped-to-flexi",
        selectArrangement: "select-arrangement",
        gadReview: "gad-review",
        backOffice: "back-office",
        editIncomeWithdrawals: "edit-income-withdrawals",
        editIncomeDrawdown: "edit-income-drawdown",
        whatifEditDrawdownIncomePayment: "edit-drawdown-income-payment",
        editIncomePayments: "edit-income-payments", // edit income payments got the same meaning with edit income withdrawals in business
        cancelRegularCrystallisation: "cancel-regular-crystallisation",
        addLogo: "add-logo",
        uploadLogo: "upload-logo",
        addLogoConfirmation: "add-logo-confirmation",
        customerMerge: "customer-merge",
        selectCustomers: "select-customers",
        mergeDetails: "merge-details",
        whatIfTool: "whatiftool",
        noChangeTool: "nochangetool",
        adHocAdviserCharge: "adhoc-adviser-charge",
        oneOffWithdrawal: "oneoff-withdrawal",
        cgt: "cgt",
        customer: "customer",
        beneficiary: "beneficiary",
        workflow: "workflow",
        investmentDetails: "investment-details",
        ppToProduct: "pp-to-product",
        ppToAbrdnSIPP:'pp-to-AbrdnSIPP',
    };

    public static Method_CloseMenu = "CloseMenu";
    public static Method_DashBoardRowClick = "DashBoardRowClick";
}

export interface IParameter {
    hierarchyid: string;
    claccountid: string;
}

export const FrequencyTypeMap = {
    [Frequency.NotSpecified]: "Not Specified",
    [Frequency.Daily]: "Daily",
    [Frequency.Weekly]: "Weekly",
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half Yearly",
    [Frequency.Yearly]: "Yearly",
    [Frequency.Fortnightly]: "Fortnightly",
    [Frequency.Termly]: "Termly",
};

export const footerLabels = {
    supportLabel: "Support",
    platformSettingsLabel: "Settings",
    helpAndSupportLabel: "Help and guides",
    newsLabel: " Platform news and updates",
    settingsLabel: "Platform settings",
};

export const overlayLabels = {
    [SideMenu.Account]: "Accounts",
    [SideMenu.Dashboard]: "Dashboard",
    [SideMenu.BusinessManagement]: "Business management",
    [SideMenu.ToolLiterature]: "Tools and literature",
    [SideMenu.Admin]: "Admin",
};

export const productActionsLabels = {
    heading: "Product actions",
};

export const subMenuLabels = {
    newProductLabel: "New product",
    quoteLabel: "Quote",
    newBusinessLabel: "New business",
    createNB: "Add new account",
};

export const accountsPageLabels = {
    newClient: "New client",
    newProduct: "New product",
    runReport: "Run report",
    businessManagementRouteLabel: "business-management",
    toolsAndLiteratureRouteLabel: "tools-and-literature",
    adminRouteLabel: "admin",
    accountsRouteLabel: "account",
    clientsRouteLabel: "customer",
    dashboardRouteLabel: "dashboard",
    businessInsightClassName: "insight",
    accountsClassName: "accounts",
    toolsAndLiteratureClassName: "literature",
    adminClassName: "admin",
    dashboardClassName: "dashboard",
    clientsClassName: "customers",
};

export const FooterContents = {
    WebsiteBrandAndProviderDetails: "Platform and product provider details",
    ProviderDetailsParagraph1:
        "Wrap Platform and Fundzone are provided by Aberdeen Platform Limited, (SC180203), which is part of Aberdeen group and is authorised and regulated by the Financial Conduct Authority.",
    ProviderDetailsParagraph2:
        "Aberdeen Connect is operated by Aberdeen group, which comprises Aberdeen plc (SC286832) and its subsidiaries.",
    ProviderDetailsParagraph3:
        "All companies are registered in Scotland at 1 George Street, Edinburgh, United Kingdom, EH2 2LL.",
    ProviderDetailsParagraph4: "For more information on Aberdeen Group visit our website ",
    ProviderDetailsParagraph4Link: "www.aberdeenplc.com",
    ProviderDetailsParagraph5: "Copyright © 2025 Aberdeen. All rights reserved.",
    ProviderDetailsParagraph:
        "Wrap Platform and Fundzone are provided by Aberdeen Platform Limited, (SC180203), which is part of Aberdeen Group and is authorised and regulated by the Financial Conduct Authority. All companies are registered in Scotland at 1 George Street, Edinburgh, United Kingdom, EH2 2LL.",
};

export const searchTooltipMessage =
    "User can search on first name(s), surname, organisation or account number here. To search in the most efficient manner, enter as much of the name/number you know first. Alternatively, click Advanced search for additional search criteria";
